export const PLACEHOLDER = {
  serverUrl: '{{MCP_SERVER_URL}}',
  instanceUrl: '{{FARADAY_INSTANCE_URL}}',
  apiToken: '{{FARADAY_API_TOKEN}}',
  username: '{{FARADAY_USERNAME}}',
  password: '{{FARADAY_PASSWORD}}'
};

export const PLACEHOLDER_FALLBACK = {
  serverUrl: 'https://mcp.apps.faradaysec.com/mcp',
  instanceUrl: 'https://your-faraday-instance.com',
  apiToken: 'your-api-token',
  username: 'your-username',
  password: 'your-password'
};

/**
 * Replaces every {{PLACEHOLDER}} mark of a snippet with the matching value,
 * falling back per key to the documentation example when that value is empty.
 * The fallback is resolved key by key on purpose: spreading the values over the
 * defaults would let an empty string win and leave a raw mark in the snippet.
 *
 * @param {string} text - text containing {{PLACEHOLDER}} marks
 * @param {Object} values - { serverUrl, instanceUrl, apiToken, username, password }
 * @returns {string} the text with every known mark replaced
 */
export const resolvePlaceholders = (text, values = {}) => {
  if (typeof text !== 'string') return text;

  return Object.keys(PLACEHOLDER).reduce(
    (resolved, key) => resolved.split(PLACEHOLDER[key]).join(values[key] || PLACEHOLDER_FALLBACK[key]),
    text
  );
};
